import axios from "axios";
export default class FileController {
    static BASE_URL = "https://yck9csg4hi.execute-api.eu-central-1.amazonaws.com/Prod"; 
    static MAX_SIZE_UPLOAD_FILE = 50000000
    static uploadFile = async (file:any) => {  
        console.log(`file size: ${file.size}`)
        if(file.size > FileController.MAX_SIZE_UPLOAD_FILE){
            throw new Error(`File size is greater than 50 MB`)
        }else{

            const formData = new FormData();
            formData.append("file", file, file.name);
            const url:string = `${FileController.BASE_URL}/files`;
            return await axios({
                method: "POST",
                url: url,
                data: formData,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
        }
    }
}